var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { stringIsIso8601DateString } from '../../../helpers/DateHelpers';
import HttpMethod from './enums/HttpMethod';
import ApiResult from './models/ApiResult';
var ApiWrapper = /** @class */ (function () {
    function ApiWrapper(apiUrl) {
        this.apiUrl = apiUrl;
    }
    Object.defineProperty(ApiWrapper.prototype, "baseHeaders", {
        get: function () {
            var headers = new Headers();
            headers.append('Content-Type', 'application/json');
            return headers;
        },
        enumerable: false,
        configurable: true
    });
    ApiWrapper.prototype.setTenantId = function (tenantId) {
        if (tenantId === undefined) {
            this.tenantId = undefined;
            return;
        }
        this.tenantId = tenantId;
    };
    ApiWrapper.prototype.setCustomBaseHeaders = function (customBaseHeaders) {
        this.customBaseHeaders = customBaseHeaders;
    };
    // #region public methods
    /**
     *
     * @param apiName The name of the api endpoint
     * @param parameters Additional query string parameters, if any,
     * with property names and values as property keys and values respectively.
     * Example: { TakeCount: 10, Query: 'Name'}
     */
    ApiWrapper.prototype.get = function (apiName, parameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch(apiName, HttpMethod.GET, parameters)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.getResponseObject(response)];
                }
            });
        });
    };
    /**
     *
     * @param apiName The name of the api endpoint
     * @param parameters Additional query string parameters,
     * if any, with property names and values as property keys and values respectively.
     * Example: { TakeCount: 10, Query: 'Name'}
     * @param body The body of the HTTP request
     */
    ApiWrapper.prototype.post = function (apiName, body, parameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch(apiName, HttpMethod.POST, parameters, body)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.getResponseObject(response)];
                }
            });
        });
    };
    /**
     *
     * @param apiName The name of the api endpoint
     * @param parameters Additional query string parameters,
     * if any, with property names and values as property keys and values respectively.
     * Example: { TakeCount: 10, Query: 'Name'}
     * @param body The body of the HTTP request
     */
    ApiWrapper.prototype.patch = function (apiName, body, parameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch(apiName, HttpMethod.PATCH, parameters, body)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.getResponseObject(response)];
                }
            });
        });
    };
    /**
     *
     * @param apiName The name of the api endpoint
     * @param parameters Additional query string parameters,
     * if any, with property names and values as property keys and values respectively.
     * Example: { TakeCount: 10, Query: 'Name'}
     * @param body The body of the HTTP request
     */
    ApiWrapper.prototype.put = function (apiName, body, parameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch(apiName, HttpMethod.PUT, parameters, body)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.getResponseObject(response)];
                }
            });
        });
    };
    /**
     *
     * @param apiName The name of the api endpoint
     * @param parameters Additional query string parameters,
     * if any, with property names and values as property keys and values respectively.
     * Example: { TakeCount: 10, Query: 'Name'}
     */
    ApiWrapper.prototype.delete = function (apiName, parameters, body) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch(apiName, HttpMethod.DELETE, parameters, body)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.getResponseObject(response)];
                }
            });
        });
    };
    // #endregion
    // #region private methods
    ApiWrapper.prototype.fetch = function (apiName, method, parameters, body, isRetry) {
        if (isRetry === void 0) { isRetry = false; }
        return __awaiter(this, void 0, void 0, function () {
            var query, headers, fetchRequestInfo, fetchRequestInit, fetchResponse, activeRefreshingTokenPromise;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = this.buildQueryString(parameters);
                        headers = this.baseHeaders;
                        if (this.authenticationInformation) {
                            headers.append('Authorization', "Bearer " + this.authenticationInformation.accessToken);
                        }
                        if (this.tenantId) {
                            headers.append('x-tenant-id', this.tenantId);
                        }
                        console.log('customBaseHeaders', this.customBaseHeaders);
                        if (this.customBaseHeaders) {
                            this.customBaseHeaders.forEach(function (value, key) {
                                headers.append(key, value);
                            });
                        }
                        fetchRequestInfo = "" + this.apiUrl + apiName + "/" + query;
                        fetchRequestInit = {
                            method: method,
                            body: JSON.stringify(body),
                            headers: headers
                        };
                        return [4 /*yield*/, fetch(fetchRequestInfo, fetchRequestInit)];
                    case 1:
                        fetchResponse = _a.sent();
                        if (!(!isRetry
                            && fetchResponse.status === 401
                            && this.authenticationInformation
                            && this.authenticationInformation.refreshToken)) return [3 /*break*/, 3];
                        activeRefreshingTokenPromise = ApiWrapper.activeRefreshingTokenPromises.get(this.authenticationInformation);
                        if (!activeRefreshingTokenPromise) {
                            console.log('AWAITING NEW refreshAccessToken');
                            activeRefreshingTokenPromise = this.authenticationInformation.refreshAccessToken();
                            ApiWrapper.activeRefreshingTokenPromises.set(this.authenticationInformation, activeRefreshingTokenPromise);
                        }
                        else {
                            console.log('AWAITING activeRefreshingTokenPromise');
                        }
                        console.log('ApiWrapper.activeRefreshingTokenPromises', ApiWrapper.activeRefreshingTokenPromises);
                        return [4 /*yield*/, activeRefreshingTokenPromise];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, this.fetch(apiName, method, parameters, body, true)];
                    case 3: return [2 /*return*/, fetchResponse];
                }
            });
        });
    };
    ApiWrapper.prototype.buildQueryString = function (queryObject) {
        if (!queryObject) {
            return '';
        }
        return "?" + Object.keys(queryObject)
            .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(queryObject[key]); })
            .join('&');
    };
    ApiWrapper.prototype.getResponseObject = function (response) {
        return __awaiter(this, void 0, void 0, function () {
            var bodyText, data, apiResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, response.text()];
                    case 1:
                        bodyText = _a.sent();
                        try {
                            // Convert all DateTime strings into a Date object
                            data = JSON.parse(bodyText, function (_key, value) {
                                if (typeof value === 'string' && stringIsIso8601DateString(value)) {
                                    return new Date(value);
                                }
                                return value;
                            });
                        }
                        catch (_b) {
                            data = bodyText;
                        }
                        apiResult = new ApiResult(response.status, data, undefined);
                        apiResult.setTotalFromString(response.headers.get('x-total-count'));
                        return [2 /*return*/, apiResult];
                }
            });
        });
    };
    return ApiWrapper;
}());
export default ApiWrapper;
//# sourceMappingURL=ApiWrapper.js.map